import { METRICS } from "@/data/project";

const Metrics = () => {
  return (
    <section
      id="datos"
      data-testid="metrics-section"
      className="relative py-24 md:py-32 bg-white border-y border-[var(--co-border)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-[var(--co-accent)] uppercase tracking-[0.25em] text-xs font-semibold">
            <span className="h-px w-8 bg-[var(--co-accent)]" />
            03 · Datos del mercado
          </span>
          <h2 className="mt-6 font-display text-[var(--co-primary)] text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
            Un mercado captivo.
            <br />
            <span className="text-[var(--co-text-muted)]">Datos que respaldan la inversión.</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border border-[var(--co-border)]">
          {METRICS.map((m, i) => (
            <div
              key={m.label}
              data-testid={`metric-${i}`}
              className={`p-8 md:p-10 bg-white hover:bg-[var(--co-bg)] transition-colors duration-300 ${
                i < METRICS.length - 1 ? "lg:border-r border-[var(--co-border)]" : ""
              } ${i < 2 ? "sm:border-b lg:border-b-0 border-[var(--co-border)]" : ""}`}
            >
              <p className="metric-number text-5xl md:text-6xl text-[var(--co-primary)]">
                {m.value}
                <span className="text-[var(--co-accent)]">{m.suffix}</span>
              </p>
              <p className="mt-4 font-display font-bold text-[var(--co-text)] uppercase tracking-wider text-sm">
                {m.label}
              </p>
              <p className="mt-2 text-sm text-[var(--co-text-muted)] leading-relaxed">
                {m.sublabel}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Metrics;
